/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import MapLoader from "./modules/MapLoader";
import BannerSlider from "./modules/BannerSlider";
import ToggleMenu from "./modules/ToggleMenu";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const bannerSlider = new BannerSlider();
    const myMapLoader = new MapLoader();
    const toggleMenu = new ToggleMenu();
});
